"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var OVERLAY_ANIMATIONS = {
  NO_EFFECT: 'NO_EFFECT',
  FADE_IN: 'FADE_IN',
  EXPAND: 'EXPAND',
  SLIDE_UP: 'SLIDE_UP',
  SLIDE_RIGHT: 'SLIDE_RIGHT'
};
var _default = OVERLAY_ANIMATIONS;
exports["default"] = _default;